import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-modal-information',
  templateUrl: './alert-modal-information.component.html',
  styleUrls: ['./alert-modal-information.component.scss']
})
export class AlertModalInformationComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}
